import styled from 'styled-components'

export const ActionButtonsWrapper = styled.div`
  display: flex;
  gap: 12px;
  padding: 16px 24px 24px;
  flex-shrink: 0;

  @media (max-width: 1600px) {
    padding: 12px 24px 16px;
  }
`

const BaseButton = styled.button`
  min-height: 64px;
  padding: 0 24px;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: transform 0.1s, filter 0.1s, background 0.1s;
  white-space: nowrap;
  -webkit-tap-highlight-color: transparent;

  &:active {
    transform: scale(0.98);
  }
`

export const CancelButton = styled(BaseButton)`
  flex: 0 0 auto;
  min-width: 128px;
  border: 1px solid var(--color-line);
  background: #ffffff;
  color: var(--color-muted);

  &:active {
    background: var(--color-line);
  }
`

export const PayButton = styled(BaseButton)`
  flex: 1;
  min-width: 0;
  border: none;
  background: ${({ theme }) => theme.colors.primary};
  color: #ffffff;
  font-size: 1.35rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  box-shadow: 0 6px 16px -6px ${({ theme }) => theme.colors.primary}99;

  &:active {
    filter: brightness(0.92);
    box-shadow: none;
  }
`
